import { PaginatedRequestParams } from 'api';

export const LegalQueryKeys = {
  all: ['wallet'] as const,
  lists: () => [...LegalQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...LegalQueryKeys.lists(), filters] as const,
  details: () => [...LegalQueryKeys.all, 'detail'] as const,
  detail: (id: string, params?: PaginatedRequestParams) =>
    [...LegalQueryKeys.details(), id, params] as const,
};
